var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09102 9.58511C9.03852 9.57761 8.97102 9.57761 8.91102 9.58511C7.59102 9.54011 6.54102 8.46011 6.54102 7.13261C6.54102 5.77511 7.63602 4.67261 9.00102 4.67261C10.3585 4.67261 11.461 5.77511 11.461 7.13261C11.4535 8.46011 10.411 9.54011 9.09102 9.58511Z",
    stroke: "url(#paint0_linear_1481_2009)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0573 14.5349C12.7223 15.7574 10.9523 16.4999 9.00227 16.4999C7.05227 16.4999 5.28227 15.7574 3.94727 14.5349C4.02227 13.8299 4.47227 13.1399 5.27477 12.5999C7.32977 11.2349 10.6898 11.2349 12.7298 12.5999C13.5323 13.1399 13.9823 13.8299 14.0573 14.5349Z",
    stroke: "url(#paint1_linear_1481_2009)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00195 16.4998C13.1441 16.4998 16.502 13.1419 16.502 8.99976C16.502 4.85762 13.1441 1.49976 9.00195 1.49976C4.85982 1.49976 1.50195 4.85762 1.50195 8.99976C1.50195 13.1419 4.85982 16.4998 9.00195 16.4998Z",
    stroke: "url(#paint2_linear_1481_2009)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1481_2009",
    x1: 6.20835,
    y1: 8.76374,
    x2: 11.4638,
    y2: 4.66724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1481_2009",
    x1: 3.26367,
    y1: 15.6767,
    x2: 8.14872,
    y2: 7.86997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1481_2009",
    x1: 0.487714,
    y1: 13.9918,
    x2: 16.5288,
    y2: 1.50709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.0a7e86d3df2356d0022025758e722716.svg";
export { ForwardRef as ReactComponent };